import styled from 'styled-components';

export const Topic = styled.span`
	font-size: 0.9rem;
	font-weight: 600;
	margin-right: 0.5rem;

	@media (min-width: 1600px) {
		font-size: 0.9rem;
	}
`;

export const Value = styled.span`
	font-size: 0.9rem;
	font-weight: 400;

	@media (min-width: 1600px) {
		font-size: 0.9rem;
	}
`;

export const PercentileScoreContainer = styled.span`
	color: #2f54eb;
	font-weight: 600;
	font-size: 0.9rem;
	border-radius: 0.25rem;
	padding: 0.75rem 1rem;
	border: 1px solid #2f54eb;
	background-color: #2f54eb0d;
`;
